import React, { useState } from 'react';
import { techStacks } from '../../mock';
import { useI18n } from '../../i18n';

const TechStack = () => {
  const { t } = useI18n();
  const tabs = Object.keys(techStacks);
  const [active, setActive] = useState(tabs[0]);
  const items = techStacks[active];

  return (
    <section className="py-20 lg:py-24 bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-400">{t('tech.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold">{t('tech.title')}</h2>
          <p className="mt-4 text-slate-300">{t('tech.body')}</p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {tabs.map((tab) => (
            <button key={tab} onClick={() => setActive(tab)}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${
                active === tab ? 'bg-orange-500 text-white border-orange-500' : 'bg-white/5 text-slate-200 border-white/10 hover:bg-white/10'
              }`}>{tab}</button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((item) => (
            <div key={item.name} className="group flex flex-col items-center gap-3 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 hover:border-orange-400/50 p-5 transition-colors">
              <img src={item.icon} alt={item.name} className="h-12 w-12 object-contain group-hover:scale-110 transition-transform" />
              <div className="text-sm text-slate-200">{item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
